import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

export type DateOrString = Date | string;

@Pipe({
    name: 'monthsBetween',
    standalone: false
})
export class MonthsBetweenPipe implements PipeTransform {
  transform({
    fromDate,
    toDate,
  }: {
    fromDate: DateOrString;
    toDate: DateOrString;
  }): number {
    const months = moment(toDate).diff(fromDate, 'months');
    return months + 1;
  }
}
